<script>
import axios from '@/utils/axios';

const MONTHS = [
  { v: 1, l: 'January' }, { v: 2, l: 'February' }, { v: 3, l: 'March' },
  { v: 4, l: 'April' }, { v: 5, l: 'May' }, { v: 6, l: 'June' },
  { v: 7, l: 'July' }, { v: 8, l: 'August' }, { v: 9, l: 'September' },
  { v: 10, l: 'October' }, { v: 11, l: 'November' }, { v: 12, l: 'December' },
];
const MONTH_NAMES = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default {
  data() {
    const now = new Date();
    return {
      months: MONTHS,
      years: [2024, 2025, 2026, 2027],
      sel: { month: now.getMonth() + 1, year: now.getFullYear() },
      slip: null,
      loadingSlip: false,
      slipError: '',
      history: [],
      loadingHistory: false,
      employeeId: null,
      downloading: false,
    };
  },
  computed: {
    period() {
      if (!this.slip) return '';
      return `${MONTH_NAMES[this.slip.month] || this.slip.month} ${this.slip.year}`;
    },
        initial() {
      return (this.slip?.employee?.name || '?').trim().charAt(0).toUpperCase();
    },
    totalDeductions() {
      if (!this.slip) return 0;
      return this.num(this.slip.total_deductions) + this.num(this.slip.unpaid_deduction) + this.num(this.slip.late_deduction);
    },
    fileName() {
      const n = (this.slip?.employee?.name || 'Employee').trim().replace(/\s+/g, '_');
      return `Payslip_${n}_${this.period.replace(/\s+/g, '_')}.pdf`;
    },
  },
  mounted() {
    try {
      const u = JSON.parse(localStorage.getItem('auth_user')) || {};
      this.employeeId = u.employee?.id || null;
    } catch { this.employeeId = null; }
    this.fetchSlip();
    if (this.employeeId) this.fetchHistory();
  },
  methods: {
    money(v) {
      const n = parseFloat(v);
      if (isNaN(n)) return '₹0';
      return '₹' + n.toLocaleString('en-IN', { maximumFractionDigits: 0 });
    },
    num(v) { return parseFloat(v) || 0; },
    monthName(m) { return MONTH_NAMES[m] || m; },

    async fetchSlip() {
      this.loadingSlip = true;
      this.slipError = '';
      this.slip = null;
      try {
        const res = await axios.get('/hrms/payroll/my-payslip', {
          params: { month: this.sel.month, year: this.sel.year },
        });
        this.slip = res.data.data;
      } catch (e) {
        this.slipError = e.message || 'No payslip found for this period.';
      } finally {
        this.loadingSlip = false;
      }
    },

    async fetchHistory() {
      this.loadingHistory = true;
      try {
        const res = await axios.get(`/hrms/payroll/payslip/${this.employeeId}/history`);
        this.history = res.data.data || [];
      } catch (e) { console.log(e.message); }
      finally { this.loadingHistory = false; }
    },

    pickHistory(h) {
      this.sel.month = h.month;
      this.sel.year = h.year;
      this.fetchSlip();
    },
        async downloadPdf() {
      if (!this.slip || this.downloading) return;
      this.downloading = true;
      try {
        const { default: html2pdf } = await import('html2pdf.js');
        await html2pdf().set({
          margin: 0,
          filename: this.fileName,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true, backgroundColor: '#ffffff' },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        }).from(this.$refs.printEl).save();
      } catch (e) {
        this.$swalToast('PDF download failed. Please try again.', 'error');
      } finally {
        this.downloading = false;
      }
    },
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">

      <!-- Top bar -->
      <div class="mp-top">
        <div>
          <h4 class="page-title mb-1">My Payslip</h4>
          <div class="mp-top-sub">Select a month to view your payslip and download it as a PDF</div>
        </div>
        <div class="mp-filters">
          <select class="form-select form-select-sm" v-model="sel.month" @change="fetchSlip">
            <option v-for="m in months" :key="m.v" :value="m.v">{{ m.l }}</option>
          </select>
          <select class="form-select form-select-sm" v-model="sel.year" @change="fetchSlip">
            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
          </select>
          <button class="btn btn-primary mp-dl" :disabled="!slip || downloading" @click="downloadPdf">
            <span v-if="downloading" class="spinner-border spinner-border-sm me-2"></span>
            <i v-else class="ti ti-download me-2"></i>{{ downloading ? 'Preparing...' : 'Download PDF' }}
          </button>
        </div>
      </div>

      <div class="row g-3">
        <!-- Payslip -->
        <div class="col-xl-8">
          <div class="mp-card">

            <div v-if="loadingSlip" class="mp-state"><div class="spinner-border text-primary"></div></div>

            <div v-else-if="slipError" class="mp-state text-muted">
              <i class="ti ti-file-off d-block mb-2" style="font-size:38px; opacity:.35;"></i>
              <div style="font-size:14px;">{{ slipError }}</div>
              <div style="font-size:12px; color:#cbd5e1; margin-top:4px;">Payroll for this month may not be processed yet.</div>
            </div>

            <template v-else-if="slip">
              <!-- Hero -->
              <div class="mp-hero">
                <div class="mp-hero-left">
                  <div class="mp-avatar">{{ initial }}</div>
                  <div>
                    <div class="mp-name">{{ slip.employee?.name }}</div>
                    <div class="mp-sub">{{ slip.employee?.email }}</div>
                  </div>
                </div>
                <span class="mp-period"><i class="ti ti-calendar me-1"></i>{{ period }}</span>
              </div>

              <!-- Attendance -->
              <div class="mp-att">
                <div class="mp-att-item"><span class="mp-att-num">{{ num(slip.working_days) }}</span><span class="mp-att-lbl">Working</span></div>
                <div class="mp-att-item"><span class="mp-att-num" style="color:#16a34a;">{{ num(slip.present_days) }}</span><span class="mp-att-lbl">Present</span></div>
                <div class="mp-att-item"><span class="mp-att-num" style="color:#dc2626;">{{ num(slip.absent_days) }}</span><span class="mp-att-lbl">Absent</span></div>
                <div class="mp-att-item"><span class="mp-att-num" style="color:#ea580c;">{{ num(slip.paid_leave_days) + num(slip.unpaid_leave_days) }}</span><span class="mp-att-lbl">Leave</span></div>
                <div class="mp-att-item"><span class="mp-att-num" style="color:#d97706;">{{ num(slip.late_count) }}</span><span class="mp-att-lbl">Late</span></div>
                <div class="mp-att-item"><span class="mp-att-num" style="color:#2563eb;">{{ num(slip.holiday_days) }}</span><span class="mp-att-lbl">Holidays</span></div>
              </div>

              <div class="row g-3">
                <!-- Earnings -->
                <div class="col-md-6">
                  <div class="mp-box">
                    <div class="mp-sec-title mp-earn"><i class="ti ti-trending-up"></i>Earnings</div>
                    <div class="mp-rows">
                      <div v-for="(e, i) in slip.earnings" :key="'e'+i" class="mp-row">
                        <span class="mp-row-name">{{ e.component_name }}</span>
                        <span class="mp-amt">{{ money(e.amount) }}</span>
                      </div>
                    </div>
                    <div class="mp-total"><span>Total Earnings</span><span style="color:#16a34a;">{{ money(slip.total_earnings) }}</span></div>
                  </div>
                </div>

                <!-- Deductions -->
                <div class="col-md-6">
                  <div class="mp-box">
                    <div class="mp-sec-title mp-deduct"><i class="ti ti-trending-down"></i>Deductions</div>
                    <div class="mp-rows">
                      <div v-for="(d, i) in slip.deductions" :key="'d'+i" class="mp-row">
                        <span class="mp-row-name">{{ d.component_name }}</span>
                        <span class="mp-amt">{{ money(d.amount) }}</span>
                      </div>

                      <div v-if="num(slip.unpaid_deduction) > 0" class="mp-row">
                        <div class="mp-row-left">
                          <span class="mp-row-name">Unpaid / Absent</span>
                          <span class="mp-row-sub">{{ num(slip.absent_days) + num(slip.unpaid_leave_days) }} day(s) salary cut</span>
                        </div>
                        <span class="mp-amt mp-neg">- {{ money(slip.unpaid_deduction) }}</span>
                      </div>

                      <div v-if="num(slip.late_count) > 0 || num(slip.late_deduction) > 0" class="mp-row">
                        <div class="mp-row-left">
                          <span class="mp-row-name">Late Penalty</span>
                          <span class="mp-row-sub">
                            {{ num(slip.late_count) }} late ·
                            {{ num(slip.late_penalty_days) > 0 ? num(slip.late_penalty_days) + ' day penalty' : 'no penalty' }}
                          </span>
                        </div>
                        <span class="mp-amt" :class="num(slip.late_deduction) > 0 ? 'mp-neg' : 'mp-muted'">
                          {{ num(slip.late_deduction) > 0 ? '- ' : '' }}{{ money(slip.late_deduction) }}
                        </span>
                      </div>

                      <div v-if="!slip.deductions?.length && !num(slip.unpaid_deduction) && !num(slip.late_count)" class="mp-row">
                        <span class="mp-row-name mp-muted">No deductions</span>
                      </div>
                    </div>
                    <div class="mp-total"><span>Total Deductions</span><span style="color:#dc2626;">{{ money(totalDeductions) }}</span></div>
                  </div>
                </div>
              </div>

              <!-- Net -->
              <div class="mp-net">
                <div>
                  <div class="mp-net-lbl">Net Salary</div>
                  <div class="mp-net-sub">Take-home for {{ period }}</div>
                </div>
                <span class="mp-net-amt">{{ money(slip.net_salary) }}</span>
              </div>

              <div class="mp-ctc">
                <span>Monthly CTC <b>{{ money(slip.ctc_monthly) }}</b></span>
                <span class="mp-dot"></span>
                <span>Gross <b>{{ money(slip.gross_salary) }}</b></span>
              </div>
            </template>

          </div>
        </div>

        <!-- History -->
        <div class="col-xl-4">
          <div class="mp-card mp-hist-card">
            <div class="mp-hist-head">
              <i class="ti ti-history"></i> Payslip History
            </div>
            <div v-if="loadingHistory" class="text-center py-3"><div class="spinner-border spinner-border-sm text-primary"></div></div>
            <div v-else-if="!history.length" class="text-center py-4 text-muted" style="font-size:12.5px;">
              <i class="ti ti-history d-block mb-2" style="font-size:26px; opacity:.4;"></i>
              No history yet.
            </div>
            <div v-else class="mp-hist">
              <div v-for="(h, i) in history" :key="i" class="mp-hist-item" @click="pickHistory(h)"
                :class="{ active: h.month === sel.month && h.year === sel.year }">
                <div>
                  <div class="mp-hist-period">{{ monthName(h.month) }} {{ h.year }}</div>
                  <span class="mp-hist-st" :class="'pr-' + h.status">{{ h.status }}</span>
                </div>
                <div class="mp-hist-net">{{ money(h.net_salary) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <app-footer></app-footer>
  </div>

  <!-- ===== Hidden A4 layout, sirf PDF ke liye ===== -->
  <div class="pdf-offscreen" aria-hidden="true">
    <div v-if="slip" ref="printEl" class="pdf-page">
      <div class="pdf-header">
        <div>
          <div class="pdf-company">Algo Ads Pvt. Ltd.</div>
          <div class="pdf-doc">Payslip for {{ period }}</div>
        </div>
        <div class="pdf-badge">PAYSLIP</div>
      </div>

      <div class="pdf-emp">
        <div><span>Employee</span><b>{{ slip.employee?.name }}</b></div>
        <div><span>Email</span><b>{{ slip.employee?.email }}</b></div>
        <div><span>Mobile</span><b>{{ slip.employee?.mobile || '-' }}</b></div>
        <div><span>Pay Period</span><b>{{ period }}</b></div>
      </div>

      <table class="pdf-att">
        <tr>
          <th>Working</th><th>Present</th><th>Absent</th><th>Leave</th><th>Late</th><th>Holidays</th>
        </tr>
        <tr>
          <td>{{ num(slip.working_days) }}</td>
          <td>{{ num(slip.present_days) }}</td>
          <td>{{ num(slip.absent_days) }}</td>
          <td>{{ num(slip.paid_leave_days) + num(slip.unpaid_leave_days) }}</td>
          <td>{{ num(slip.late_count) }}</td>
          <td>{{ num(slip.holiday_days) }}</td>
        </tr>
      </table>

      <div class="pdf-cols">
        <div class="pdf-col">
          <div class="pdf-th pdf-th-earn">Earnings</div>
          <div v-for="(e, i) in slip.earnings" :key="'pe'+i" class="pdf-tr">
            <span>{{ e.component_name }}</span><span>{{ money(e.amount) }}</span>
          </div>
          <div class="pdf-tr pdf-tr-total"><span>Total Earnings</span><span>{{ money(slip.total_earnings) }}</span></div>
        </div>
        <div class="pdf-col">
          <div class="pdf-th pdf-th-ded">Deductions</div>
          <div v-for="(d, i) in slip.deductions" :key="'pd'+i" class="pdf-tr">
            <span>{{ d.component_name }}</span><span>{{ money(d.amount) }}</span>
          </div>
          <div v-if="num(slip.unpaid_deduction) > 0" class="pdf-tr">
            <span>Unpaid / Absent</span><span>{{ money(slip.unpaid_deduction) }}</span>
          </div>
          <div v-if="num(slip.late_deduction) > 0" class="pdf-tr">
            <span>Late Penalty ({{ num(slip.late_count) }} late, {{ num(slip.late_penalty_days) }} day)</span>
            <span>{{ money(slip.late_deduction) }}</span>
          </div>
          <div class="pdf-tr pdf-tr-total"><span>Total Deductions</span><span>{{ money(totalDeductions) }}</span></div>
        </div>
      </div>

      <div class="pdf-net">
        <span>Net Salary</span>
        <b>{{ money(slip.net_salary) }}</b>
      </div>

      <div class="pdf-meta">Monthly CTC: {{ money(slip.ctc_monthly) }} &nbsp;|&nbsp; Gross: {{ money(slip.gross_salary) }}</div>
      <div class="pdf-foot">This is a computer-generated payslip and does not require a signature.</div>
    </div>
  </div>
</template>

<style scoped>
.form-select { border-radius: 10px; border-color: #e2e8f0; font-size: 13px; width: auto; }
.form-select:focus { border-color: #a5b4fc; box-shadow: 0 0 0 3px rgba(79,70,229,.1); }

/* Top bar */
.mp-top { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 14px; margin-bottom: 18px; }
.mp-top-sub { font-size: 12.5px; color: #94a3b8; }
.mp-filters { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.mp-dl { background: linear-gradient(135deg,#4f46e5,#7c3aed); border: none; border-radius: 10px; font-size: 13px; font-weight: 600; padding: 7px 16px; display: inline-flex; align-items: center; }
.mp-dl:disabled { opacity: .55; }

/* Card */
.mp-card { background: #fff; border: 1px solid #eef2f7; border-radius: 16px; padding: 24px; box-shadow: 0 1px 3px rgba(0,0,0,.03); }
.mp-state { text-align: center; padding: 70px 0; }

/* Hero */
.mp-hero { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; padding-bottom: 20px; margin-bottom: 20px; border-bottom: 1px dashed #e2e8f0; }
.mp-hero-left { display: flex; align-items: center; gap: 14px; }
.mp-avatar { width: 52px; height: 52px; border-radius: 14px; background: linear-gradient(135deg,#4f46e5,#7c3aed); color: #fff; font-size: 22px; font-weight: 800; display: flex; align-items: center; justify-content: center; box-shadow: 0 8px 18px -6px rgba(79,70,229,.5); }
.mp-name { font-size: 18px; font-weight: 800; color: #0f172a; letter-spacing: -.2px; }
.mp-sub { font-size: 12.5px; color: #94a3b8; margin-top: 2px; }
.mp-period { font-size: 12px; font-weight: 600; color: #4f46e5; background: #eef2ff; padding: 6px 14px; border-radius: 20px; }

/* Attendance */
.mp-att { display: grid; grid-template-columns: repeat(6, 1fr); gap: 10px; margin-bottom: 20px; }
.mp-att-item { background: #f8fafc; border: 1px solid #eef2f7; border-radius: 12px; padding: 14px 4px; text-align: center; }
.mp-att-num { display: block; font-size: 20px; font-weight: 800; color: #0f172a; line-height: 1; }
.mp-att-lbl { display: block; margin-top: 6px; font-size: 10px; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: .4px; }
@media (max-width: 767px) { .mp-att { grid-template-columns: repeat(3, 1fr); } }

/* Earnings / Deductions */
.mp-box { border: 1px solid #eef2f7; border-radius: 14px; padding: 12px 14px 0; height: 100%; display: flex; flex-direction: column; }
.mp-sec-title { display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; padding: 8px 12px; border-radius: 8px; margin-bottom: 4px; }
.mp-sec-title i { font-size: 15px; }
.mp-earn { background: #dcfce7; color: #16a34a; }
.mp-deduct { background: #fee2e2; color: #dc2626; }
.mp-rows { flex: 1; }
.mp-row { display: flex; justify-content: space-between; align-items: center; gap: 14px; padding: 12px 6px; border-bottom: 1px solid #f1f5f9; }
.mp-rows .mp-row:last-child { border-bottom: none; }
.mp-row-left { display: flex; flex-direction: column; min-width: 0; }
.mp-row-name { font-size: 13.5px; color: #334155; font-weight: 500; }
.mp-row-sub { font-size: 11px; color: #94a3b8; margin-top: 2px; }
.mp-amt { font-size: 13.5px; font-weight: 600; color: #1e293b; white-space: nowrap; font-variant-numeric: tabular-nums; }
.mp-neg { color: #dc2626; }
.mp-muted { color: #94a3b8; }
.mp-total { display: flex; justify-content: space-between; align-items: center; margin: 4px -14px 0; padding: 13px 20px; background: #f8fafc; border-top: 1px solid #eef2f7; border-radius: 0 0 14px 14px; font-size: 13.5px; font-weight: 700; color: #0f172a; }

/* Net */
.mp-net { display: flex; justify-content: space-between; align-items: center; background: linear-gradient(135deg,#4f46e5,#7c3aed); border-radius: 16px; padding: 20px 24px; color: #fff; margin-top: 18px; box-shadow: 0 10px 24px -10px rgba(79,70,229,.55); }
.mp-net-lbl { font-size: 14px; font-weight: 700; }
.mp-net-sub { font-size: 11px; opacity: .75; margin-top: 3px; }
.mp-net-amt { font-size: 28px; font-weight: 800; letter-spacing: -.3px; }
.mp-ctc { display: flex; align-items: center; justify-content: center; gap: 10px; font-size: 11.5px; color: #94a3b8; margin-top: 16px; }
.mp-ctc b { color: #64748b; font-weight: 600; margin-left: 3px; }
.mp-dot { width: 4px; height: 4px; border-radius: 50%; background: #cbd5e1; }

/* History */
.mp-hist-card { padding: 18px; position: sticky; top: 90px; }
.mp-hist-head { display: flex; align-items: center; gap: 8px; font-size: 14px; font-weight: 700; color: #0f172a; margin-bottom: 14px; }
.mp-hist-head i { color: #4f46e5; font-size: 17px; }
.mp-hist { display: flex; flex-direction: column; gap: 8px; max-height: 460px; overflow-y: auto; }
.mp-hist-item { display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; border: 1px solid #eef2f7; border-radius: 12px; cursor: pointer; transition: all .15s; }
.mp-hist-item:hover { border-color: #c7d2fe; background: #f8faff; }
.mp-hist-item.active { border-color: #a5b4fc; background: #eef2ff; }
.mp-hist-period { font-size: 13px; font-weight: 700; color: #1e293b; }
.mp-hist-st { display: inline-block; font-size: 9.5px; font-weight: 600; padding: 2px 8px; border-radius: 20px; text-transform: capitalize; margin-top: 4px; }
.pr-draft { background: #f1f5f9; color: #64748b; }
.pr-processed { background: #dbeafe; color: #2563eb; }
.pr-finalized { background: #dcfce7; color: #16a34a; }
.mp-hist-net { font-size: 14px; font-weight: 800; color: #0f172a; }

/* ===== PDF layout (A4 = 794px wide) ===== */
.pdf-offscreen { position: fixed; left: -10000px; top: 0; }
.pdf-page { width: 794px; min-height: 1123px; background: #fff; padding: 44px 48px; font-family: Arial, Helvetica, sans-serif; color: #1e293b; box-sizing: border-box; }
.pdf-header { display: flex; justify-content: space-between; align-items: center; padding-bottom: 18px; border-bottom: 3px solid #4f46e5; }
.pdf-company { font-size: 22px; font-weight: 800; color: #0f172a; }
.pdf-doc { font-size: 13px; color: #64748b; margin-top: 4px; }
.pdf-badge { background: #4f46e5; color: #fff; font-size: 13px; font-weight: 700; letter-spacing: 2px; padding: 8px 18px; border-radius: 6px; }

.pdf-emp { display: grid; grid-template-columns: 1fr 1fr; gap: 14px 24px; margin: 24px 0; padding: 18px 20px; background: #f8fafc; border-radius: 10px; }
.pdf-emp span { display: block; font-size: 10.5px; text-transform: uppercase; letter-spacing: .5px; color: #94a3b8; margin-bottom: 3px; }
.pdf-emp b { font-size: 13.5px; color: #0f172a; }

.pdf-att { width: 100%; border-collapse: collapse; margin-bottom: 24px; }
.pdf-att th { background: #eef2ff; color: #4f46e5; font-size: 11px; text-transform: uppercase; padding: 9px 6px; border: 1px solid #e2e8f0; }
.pdf-att td { text-align: center; font-size: 15px; font-weight: 700; padding: 11px 6px; border: 1px solid #e2e8f0; }

.pdf-cols { display: flex; gap: 20px; align-items: stretch; }
.pdf-col { flex: 1; border: 1px solid #e2e8f0; border-radius: 10px; overflow: hidden; display: flex; flex-direction: column; }
.pdf-th { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; padding: 10px 14px; }
.pdf-th-earn { background: #dcfce7; color: #15803d; }
.pdf-th-ded { background: #fee2e2; color: #b91c1c; }
.pdf-tr { display: flex; justify-content: space-between; gap: 12px; padding: 10px 14px; font-size: 12.5px; border-bottom: 1px solid #f1f5f9; }
.pdf-tr-total { margin-top: auto; background: #f8fafc; font-weight: 700; border-top: 1px solid #e2e8f0; border-bottom: none; }

.pdf-net { display: flex; justify-content: space-between; align-items: center; margin-top: 24px; padding: 18px 22px; background: #4f46e5; color: #fff; border-radius: 10px; font-size: 15px; font-weight: 700; }
.pdf-net b { font-size: 26px; }
.pdf-meta { text-align: center; font-size: 11.5px; color: #64748b; margin-top: 16px; }
.pdf-foot { text-align: center; font-size: 10.5px; color: #94a3b8; margin-top: 60px; padding-top: 14px; border-top: 1px dashed #e2e8f0; }
</style>